<template>
  <v-layout fill-height column class="page-solution-breath">
    <v-img :src="$downUrl(imgFileName)"
           class="grey lighten-2 bg-img" />
    <v-layout class="answer" justify-center align-center>
      <!-- 훈련형 -->
      <div v-if="training" class="solution-breath">
        <div class="solution-breath-timer">{{ resTimeData }}</div>
        <div class="solution-breath-content">
          <div :class="[{'pause':pause},'breath-animation']"></div>
        </div>
        <div class="solution-breath-bottom">
          <v-btn icon @click="pauseClick">
            <Pause :pause="pause"/>
          </v-btn>
        </div>
      </div>
      <!-- 완료 -->
      <div v-else class="solution-breath">
        <v-layout class="solution-breath-content" justify-center align-center>
          <CompleteCheck/>
          <div class="fs-31 fw-400 white--text ms-3">완료</div>
        </v-layout>
      </div>
    </v-layout>
  </v-layout>
</template>
<script>
import Pause from "@/components/icons/Pause"
import CompleteCheck from "@/components/icons/CompleteCheck"
import store from '../../../store'

export default {
  props: ["current", "total", "unitUseNo", "unitDtlUseList", "freeYn", "cmpltYn", "unitDtlUseNo", "unitDtlPageSeq"],
  data: () => ({
    pause: false,
    training: true, /* 트레이닝 중인지.. */
    min: 0,
    sec: 0,
    timeCounter: 0, //3분
    resTimeData: '',
    imgNo: null,
    imgFileName: null
  }),
  components: {
    Pause,
    CompleteCheck
  },
  computed: {},
  created() {
    this.getUnitDetailUse()
  },
  methods: {
    async getUnitDetailUse() {
      // 유닛 사용 번호
      // console.log('unitUseNo : ', this.unitUseNo)
      // 유닛상세 사용 번호
      // console.log('unitDtlUseNo : ', this.unitDtlUseNo)
      // console.log('unitDtlUseNo : ', this.unitDtlUseNo[this.current-1])
      // console.log('unitDtlPageSeq : ', this.unitDtlPageSeq)
      // console.log('unitDtlPageSeq : ', this.unitDtlPageSeq[this.current-1])

      // 무료 여부
      this.free = this.freeYn
      // 완료 여부
      this.cmplt = this.cmpltYn

      await store.dispatch('getUnitDetailUse', this.$_payload('so',
          [{'unitUseNo': this.unitUseNo},
            {'unitDtlUseNo': this.unitDtlUseNo[this.current - 1]},
            {'unitDtlPageSeq': this.unitDtlPageSeq[this.current - 1]},
            {'freeYn': this.free},
            {'feedbackUserKey': this.$route.query.feedbackUserKey}
          ]))
        .then(res => {
          if (res.success) {

            // 질문 리스트
            res.data.unitDtlQuesList.forEach((quesEl) => {

              this.imgNo = quesEl.imgAtchNo
              this.imgFileName = quesEl.imgAtchFileName
              // 질문 관리자 지정 시간 셋팅
              if (quesEl.timeType == '02') {
                this.min = quesEl.timeSet.substr(0, 2)
                this.sec = quesEl.timeSet.substr(2, 2)
              }

              // 앞에이지의 유저 답변 시간
              if (quesEl.memberUnitDtlReplyList.length > 0) {
                quesEl.memberUnitDtlReplyList.forEach((userReplyEl) => {
                  // this.userReplyNo[i+j] = userReplyEl.memberUnitDtlReplyUseNo
                  // this.timeSet = userReplyEl.reply
                  this.min = userReplyEl.reply.substr(0, 2)
                  this.sec = userReplyEl.reply.substr(2, 2)
                });
              }

              // 초변환
              this.timeCounter = (parseInt(this.min) * 60) + parseInt(this.sec)
              console.log('this.timeCounter : ', this.timeCounter)

            });
          } else {
            console.log(res.msg)
            // this.answer = [];
          }
        })
        .catch(error => {
          console.error(error)
          // this.answer = [];
        })
        .finally(() => {
          this.start()
        })
    },
    pauseClick() {
      this.pause = !this.pause;

      if (this.pause) {
        this.timeStop()
      } else {
        this.reStart()
      }

    },
    start() {
      // 1초에 한번씩 start 호출
      this.polling = setInterval(() => {
        // this.timeCounter-- //1 감소
        this.resTimeData = this.prettyTime()
        this.timeCounter-- //1 감소

        // console.log("timeCounter : ", this.timeCounter)
        // console.log("resTimeData : ", this.resTimeData)

        if (this.timeCounter < 0) this.timeStop()

      }, 1000)
    },
    // 시간 형식으로 변환 리턴
    prettyTime() {
      let time = this.timeCounter / 60
      let minutes = parseInt(time)
      let secondes = Math.round((time - minutes) * 60)
      return this.pad(minutes, 2) + ":" + this.pad(secondes, 2)
    },
    // 2자리수로 만들어줌 09,08...
    pad(n, width) {
      n = n + '';
      return n.length >= width ? n : new Array(width - n.length + 1).join('0') + n
    },
    timeStop() {
      clearInterval(this.polling)
      if (this.timeCounter <= 0) {
        this.training = false
        setTimeout(() => this.$emit('next'), 3000); // 3초이후 이동
      }
    },
    // 재실행
    reStart() {
      clearInterval(this.polling)
      this.start()
    },
  },
  beforeDestroy() {
    clearInterval(this.polling)
  }
}
</script>
